import axios from "../plugins/parseAxios";
export class AccountingProductAPI {
  constructor(props) {}
  static getAccountingProducts(payload) {
    return axios.post("functions/getAccountingProducts", payload);
  }
  static createAccountingProduct(formData) {
    return axios.post("functions/createAccountingProduct", formData);
  }
  static updateAccountingProduct(formData) {
    return axios.post("functions/updateAccountingProduct", formData);
  }
  static getAccountingProductsByIds(ids) {
    return axios.post("functions/getAccountingProductsByIds", {
      ids
    });
  }
  static removeAccountingProduct(id) {
    return axios.post("functions/removeAccountingProduct", {
      id
    });
  }
}
